import { render, staticRenderFns } from "./sectionDataPreviewResume.vue?vue&type=template&id=5aca0708&scoped=true"
import script from "./sectionDataPreviewResume.vue?vue&type=script&lang=js"
export * from "./sectionDataPreviewResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aca0708",
  null
  
)

export default component.exports